export default "__VITE_ASSET__BoQbqz1s__"